import { Button, Checkbox, Group, Stack, Text } from '@mantine/core';
import { closeAllModals, openModal } from '@mantine/modals';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { SvgWarning } from '@/components/Common/icon';

export interface RemoveDialogProps {
  title?: string;
  description?: string;
  confirmLabel?: string;
  onDelete?: () => Promise<void>;
}

export const openRemoveDialog = (props: RemoveDialogProps) => {
  openModal({
    title: (
      <div className="font-bold text-xl pl-8">
        <span className="absolute left-4">
          <SvgWarning />
        </span>
        {props.title ?? 'Delete'}
      </div>
    ),
    withinPortal: false,
    centered: true,
    radius: 'md',
    children: <RemoveDialog {...props} />,
  });
};

const RemoveDialog: FC<RemoveDialogProps> = ({ confirmLabel, description, onDelete }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(true);

  const handleDelete = async () => {
    setLoading(true);
    await onDelete?.();
    setLoading(false);
    handleCancel();
  };

  const handleCancel = () => {
    closeAllModals();
  };

  return (
    <div className="pl-8">
      <Stack gap="md">
        {description && <Text size="sm">{description}</Text>}
        {confirmLabel && <Checkbox label={confirmLabel} onChange={(e) => setDisabled(!e.currentTarget.checked)} />}
        <Group justify="flex-end" className="mt-2">
          <Button variant="outline" onClick={handleCancel}>
            {t('alert_cancel')}
          </Button>
          <Button color="red" loading={loading} disabled={disabled} onClick={handleDelete}>
            {t('delete_btn')}
          </Button>
        </Group>
      </Stack>
    </div>
  );
};
export default RemoveDialog;
